'use client';

import { c as _c } from "react/compiler-runtime";
import { ANONYMOUS_USERNAME } from '@shared/all/helpers/anonymous';
import { VenetianMask } from 'lucide-react';
import dynamic from 'next/dynamic';
import AppLayout from '../../../layouts/AppLayout/AppLayout';

// The feed is client-only everywhere else too: Profile mounts it behind its
// loaded-data guard, so it never server-renders. Rendering it during SSR here
// threw and blanked the whole page.
const Posts = dynamic(() => import('../../../components/posts/Posts'), {
  ssr: false
});
type Props = {
  isEmbed?: boolean;
};

// /user/Anonymous%20User is not a profile. Anonymous posts mask their author as
// ANONYMOUS_USERNAME, which can never be a real account, so rather than 404 the
// author link we show what that name actually stands for: the anonymous posts.
const AnonymousProfile = t0 => {
  const $ = _c(5);
  const {
    isEmbed: t1
  } = t0;
  const isEmbed = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-background-primary text-textSecondary"><VenetianMask size={24} /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex"><div className="w-full"><div className="mt-16 rounded-lg bg-background-secondary p-5 shadow-lg"><div className="flex items-center gap-3">{t2}<div className="min-w-0"><h1 className="text-lg font-semibold text-textPrimary">Anonymous</h1><p className="text-sm text-textSecondary">Posts published without an author. There is no profile behind this name.</p></div></div></div></div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Posts params={{
      source: "anonymous"
    }} uniqueId={ANONYMOUS_USERNAME} disableLink={false} isFullLength={false} />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isEmbed) {
    t5 = <AppLayout topBanner={t3} isEmbed={isEmbed}>{t4}</AppLayout>;
    $[3] = isEmbed;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
};
export default AnonymousProfile;